// The saved session owns the work. This queue only schedules follow-up HTTP
// requests, so navigation or a failed request cannot lose knowledge evidence.
export const createKnowledgeCheckQueue = ({ load, accept, currentPlayerId, onState = () => {} }) => {
  let running = false, requestedPlayerId = '', timer = null, disposed = false;
  let retryPlayerId = '', failures = 0;
  const schedule = (delay = 0) => {
    if (running || timer !== null) return;
    timer = setTimeout(async () => {
      timer = null;
      running = true;
      const playerId = requestedPlayerId;
      requestedPlayerId = '';
      if (disposed || currentPlayerId() !== playerId) { running = false; return; }
      onState({ playerId, status: 'processing' });
      let retryDelay = 0;
      try {
        const next = await load(playerId);
        if (!disposed && currentPlayerId() === playerId) {
          accept(next);
          failures = 0;
          retryPlayerId = '';
          onState({ playerId, status: next?.knowledgeCheckPending ? 'processing' : 'idle' });
          if (next?.knowledgeCheckPending) requestedPlayerId ||= playerId;
        }
      } catch {
        if (!disposed && currentPlayerId() === playerId) {
          failures = retryPlayerId === playerId ? failures + 1 : 1;
          retryPlayerId = playerId;
          retryDelay = Math.min(30000, 1000 * 2 ** Math.min(failures - 1, 5));
          requestedPlayerId ||= playerId;
          onState({ playerId, status: 'retrying' });
        }
      } finally {
        running = false;
        if (!disposed && requestedPlayerId) schedule(requestedPlayerId === playerId ? retryDelay : 0);
      }
    }, delay);
  };
  const request = playerId => {
    if (disposed || !playerId) return;
    if (requestedPlayerId && requestedPlayerId !== playerId && timer !== null) {
      clearTimeout(timer);
      timer = null;
    }
    requestedPlayerId = playerId;
    schedule();
  };
  return { request, dispose() { disposed = true; requestedPlayerId = ''; clearTimeout(timer); } };
};
